module.exports = __webpack_public_path__ + "img/viber.40c6a9d8.png";